import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  badge: {
    display: 'inline-block',
    fontSize: '.55rem',
    backgroundColor: t.primary,
    color: t.white,
    borderRadius: '.25rem',
    padding: '.025rem .25rem',
    textTransform: 'uppercase',
  },
}))

export default useStyles
